import React from "react";
import Header from "../homepage/header.js";
import Section2 from "../homepage/section2.js";
import Section3 from "../homepage/section3.js";
import Section4 from "../homepage/section4.js";
import Section6 from "../homepage/section6.js";
import Section7 from "../homepage/section7.js";
import Stats from "../../components/homepage/stats.js";
import Bank from "../../components/homepage/bank.js";
import { Helmet } from "react-helmet";

import "../../../src/App.css"; // Import global styles
import Testimonials from "./testinomial.js";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Urban Nest Properties | BMRDA Approved Plots in Bangalore</title>
        <meta
          name="description"
          content="Secure your investment with BMRDA approved plots & gated community layouts near Bangalore from Urban Nest Properties. Low-risk, high-return opportunities."
        />
        <meta name="keywords" content="BMRDA approved plots, Bangalore real estate, gated communities, farm villas, Chikka Madure plots, Nelamangala property" />
        <link rel="canonical" href="https://urbannestprop.com" />
      </Helmet>
      <div className="bg-white" style={{ fontFamily: ["poppins"] }}>
        {/* Page Content */}
        <Header />
        <Section2 />
        <Section6 />
        <Section3 />
        <Section4 />
        <Stats />
        <Section7 />
        <Testimonials />
        <Bank />
      </div>
    </>
  );
}
